import { Button } from '@customerio/pluma-components/react';
import { useCurrentWorkspace } from '@/context/current-workspace';
import { useAnalytics } from '@/services/analytics';
import { useSampleWorkspace } from '@/features/workspaces';

type SampleWorkspaceViewButtonProps = {
  /** This page's URL in the sample workspace. */
  href: (sampleWorkspaceId: number) => string;
  /** The page name the click reports. */
  routeName: string;
};

/**
 * "View sample workspace": opens the page the reader is on inside the sample workspace, so a
 * first-run page can show what it looks like with data in it. Hidden where there is no sample
 * workspace to go to — Builder plans have none — and inside the sample workspace itself.
 */
export function SampleWorkspaceViewButton({ href, routeName }: SampleWorkspaceViewButtonProps) {
  const workspace = useCurrentWorkspace();
  const { sampleWorkspaceId, isSampleWorkspace } = useSampleWorkspace();
  const { track } = useAnalytics();

  if (sampleWorkspaceId == null || isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return (
    <Button
      icon="trigger-event"
      iconPosition="trailing"
      href={href(sampleWorkspaceId)}
      onClick={() => void track('sampleWorkspace', 'viewSampleWorkspaceClicked', { 'Route Name': routeName })}
    >
      View sample workspace
    </Button>
  );
}
